import media from "styles/media"
import text from "styles/text"
import styled from "styled-components"
import { useMemo } from "react"
import { checkedLocaleLink } from "utils/routes"
import SeafoamLine from "components/buttons/SeafoamLine"
import { useI18next } from "gatsby-plugin-react-i18next"

type Link = {
  title: string;
  url: string;
};

interface PopoutLinksCardProps {
  title: string; // The title of the section
  links: Link[]; // Array of links, each with a title and URL
  translation: Record<string, string>; // Translation dictionary, where the key is the link's title
  languageOverride?: string; // Optional language override
}


export default function PopoutLinksCard({
    title,links,translation,languageOverride
  }: PopoutLinksCardProps) {
    const { language } = useI18next();
    const allLinks = useMemo(
    () =>
      links.map((link:Link) => {
        const localeLink = checkedLocaleLink(
          link.url,
          languageOverride ?? language
        )

        return (
          <SeafoamLine href={localeLink} key={link.title}>
            {translation[link.title]}
          </SeafoamLine>
        )
      }),
    [links, translation, language, languageOverride]
  )
    return <>
        <Container>
            <Title>{translation[title]}</Title>
            <Links>
                {allLinks}
            </Links>
        </Container>
    </>

  }
const Container = styled.div`
  border-radius:10px;
  display: flex;
  flex-direction: column;
`
const Title = styled.h6`
  ${media.fullWidth} {
    margin: 25px;
    margin-top:20px;
  }
  ${media.tablet} {
    margin: 2.883vw;
    margin-top: 2.441vw;
  }
  margin: 1.512vw;
  margin-top: 1.222vw;
  color: #ffffff;
  ${text.h6}
  font-size: 18px;
  ${media.desktop} {
    font-size: 1.226vw;
  }
  ${media.tablet} {
    font-size: 2.044vw;
  }
  ${media.mobile} {
    font-size: 5.9vw;
  }
`
const Links = styled.div`
  ${media.fullWidth} {
    margin: 25px;
    margin-top:0;
  }
  ${media.tablet} {
    margin: 2.883vw;
    margin-top:0;
  }
  margin: 1.512vw;
  margin-top:0;
`